import React, { useEffect, useRef, useState } from 'react'
import style from './LessonDiscussion.module.scss'
import TextareaMarkup from '../../../UI/TextareaMarkup/TextareaMarkup'
import Message from './Message/Message'
import { superAxiosRequest } from '../../../../axiosApi'
import { useParams } from 'react-router-dom'
import Loader from '../../../UI/Loader/Loader'

const LessonDiscussion = ({ context, studentId, setRef, translate }) => {
  const { hash } = useParams()

  const [dialogText, setDialogText] = useState('')
  const [chatId, setChatId] = useState(null)
  const [allMessages, setAllMessages] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const targetRef = useRef(null)

  const onChange = (e) => {
    setDialogText(e)
  }
  const createDialog = () => {
    const requestBody = {
      hash: hash,
    }

    if (context === 'student') {
      requestBody.hash = hash
    } else {
      requestBody.student = studentId
    }

    superAxiosRequest(
      {
        link: 'ebooks/create_discussion',
        method: 'post',
      },
      requestBody,
    )
      .then((res) => {
        setChatId(res.data.id)
      })
      .catch(() => {})
  }
  const sendDialogMessage = () => {
    superAxiosRequest(
      {
        link: `ebooks/discussion/${chatId}`,
        method: 'post',
      },
      {
        text: dialogText,
      },
    ).then(() => {
      fetchMessages()
      setDialogText('')
    })
  }

  useEffect(() => {
    createDialog()
  }, [hash, studentId])

  const fetchMessages = () => {
    setIsLoading(true)
    superAxiosRequest(
      {
        link: `ebooks/discussion/${chatId}`,
        method: 'get',
      },
      {
        hash: hash,
      },
    )
      .then((res) => {
        setAllMessages(res.data)
      })
      .finally(() => setIsLoading(false))
  }

  useEffect(() => {
    if (chatId) {
      fetchMessages()
    }
  }, [chatId])

  useEffect(() => {
    if (setRef) setRef(targetRef)
  }, [])

  return (
    <div className={style.container} ref={targetRef}>
      <div className={style.header}>
        <div className={style.line}></div>
        <div className={style.text}>{translate.lesson_discussion}</div>
      </div>
      {isLoading ? (
        <Loader />
      ) : (
        <div className={style.comments}>
          {allMessages.length > 0 ? (
            allMessages.map((el, index) => {
              return <Message key={index} message={el} />
            })
          ) : (
            <div className={style.empty}>
              <h3>{translate.theres_is_no_discussion_yet}!</h3>
              <span>{translate.to_start_comment}</span>
            </div>
          )}
        </div>
      )}
      <div className={style.leaveComment}>
        <span>{translate.leave_a_comment}</span>
        <TextareaMarkup onChange={(e) => onChange(e)} value={dialogText} />
        <button className={style.btnSend} onClick={sendDialogMessage}>
          {translate.send}
        </button>
      </div>
    </div>
  )
}

export default LessonDiscussion
